<template>
  <form
    v-if="countryOptions"
    id="LocalizationForm"
    method="post"
    :action="formActionURL"
    accept-charset="UTF-8"
    class="localization-form"
    enctype="multipart/form-data"
  >
    <input
      type="hidden"
      name="form_type"
      value="localization"
    >
    <input
      type="hidden"
      name="utf8"
      value="✓"
    >
    <input
      type="hidden"
      name="_method"
      value="put"
    >
    <input
      type="hidden"
      name="return_to"
      :value="returnToURL"
    >
    <input
      v-model="selectedCountry"
      type="hidden"
      name="country_code"
    >
    <label
      class="localization-form__label"
      v-text="labelText"
    />

    <dropdown-select
      :options="countryOptions"
      :predefined-value="countryCode"
      @on-option-selected="handleCountryChange"
    />

    <input
      type="hidden"
      name="new"
      :value="countryCode"
    >

    <button
      class="btn localization-form__submit"
      type="submit"
      v-text="submitButtonText"
    />
  </form>
</template>
<script>

/**
 * Component: Localization Form
 * ------------------------------------------------------------------------------
 * Shopify Localization Form which allows customers to switch between different
 * localized versions of the store.
 */
import { v4 } from 'uuid'

import { mapState } from 'pinia'

import { useLocaleStore } from '~stores/locale'

import DropdownSelect from '~components/dropdown-select/dropdown-select'

export default {
  name: 'LocalizationForm',

  components: {
    DropdownSelect,
  },

  data() {
    return {
      selectedCountry: mint?.shop?.country,
    }
  },

  computed: {

    /**
     * Map locale state.
     */
    ...mapState(useLocaleStore, {
      countryCode: 'countryCode',
    }),

    /**
     * Calculate the localization form action url.
     * @returns {String}
     */
    formActionURL() {
      return mint.routes.root === '/'
        ? `${mint.routes.root}localization`
        : `${mint.routes.root}/localization`
    },

    /**
     * Calculate the current page URL handle to redirect here after form submission.
     * @returns {String}
     */
    returnToURL() {
      return window.location.href.replace(window.location.origin, '')
    },

    /**
     * Calculate the submit button text.
     * @returns {String}
     */
    submitButtonText() {
      return mint.strings.localization.formSubmit
    },

    /**
     * Calculate the form label text.
     * @returns {String}
     */
    labelText() {
      return mint.strings.localization.formLabel
    },

    /**
     * Calculates a formatted array of country options objects, each should
     * contain an `id`, `label` and `value`.
     * @returns {Array}
     */
    countryOptions() {
      const formattedCountries = []

      for (const country of window.mint.countries) {
        const formattedCountry = {
          id: v4(),
          label: country.countryName,
          value: country.countryCode,
        }

        formattedCountries.push(formattedCountry)
      }

      return formattedCountries
    },
  },

  methods: {

    /**
     * Event handler for country change.
     * @param {string} value - emitted option.value string.
     */
    handleCountryChange(value) {
      this.selectedCountry = value
    },
  },
}
</script>

<style src="./localization-form.scss" lang="scss"></style>
